<template>
  <div v-loading.fullscreen.lock="loading">
    <div class="container-fluid sinup-container">
      <div class="row window-hight">
        <div class="col-12 col-md-6 left-bg">
          <div class="inner-left-wrap p-2 p-md-5">
            <a href="https://homeoftraining.com" class="navbar-brand mb-3 mb-md-5">
              <img src="/signup-img/hot-logo.webp" width="186"  />
            </a>
            <div class="signin-header pt-5">
              <h3 class="mb-4">Enter Password <img src="/signup-img/fire.svg" alt=""></h3>
              <!-- <span class="d-block mb-4">Your email address is usually your username for the platform.
                Please enter your email address below and a “Reset Password” link will be sent to the email we have on
                file.
                If you do not have an email address in the system, please email us at:
                <a :href="'mailto:' + support_email">{{ support_email }}</a>.</span> -->
            </div>
            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
            <form role="form" @submit.prevent="handleSubmit(onSubmit)">
              <div class="row">
                <div class="col-md-12">
                  <base-input
                    alternative
                    type="password"
                    class="mb-2 login-input singup-input"
                    name="New password"
                    :rules="{ required: true }"
                    placeholder="New Password"
                    v-model="form.newpassword"
                  >
                  </base-input>
                </div>
                <div class="col-md-12">
                  <base-input
                    alternative
                    type="password"
                    class="mb-2 login-input singup-input"
                    name="Confirm password"
                    :rules="{ required: true }"
                    placeholder="Confirm Password"
                    v-model="form.confirmpassword"
                  >
                  </base-input>
                </div>
              </div>

              <div class="text-center signinbtn mb-3">
                <base-button native-type="submit" class="d-block w-100"
                  >Submit
                  <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M17.5467 10.9333C17.2401 10.5333 16.8667 10.1867 16.5201 9.84C15.6267 9.04 14.6134 8.46667 13.7601 7.62667C11.7734 5.68 11.3334 2.46667 12.6001 0C11.3334 0.306667 10.2267 1 9.28007 1.76C5.82673 4.53333 4.46673 9.42667 6.0934 13.6267C6.14673 13.76 6.20007 13.8933 6.20007 14.0667C6.20007 14.36 6.00007 14.6267 5.7334 14.7333C5.42673 14.8667 5.10673 14.7867 4.8534 14.5733C4.77773 14.5099 4.71444 14.4331 4.66673 14.3467C3.16007 12.44 2.92007 9.70667 3.9334 7.52C1.70673 9.33333 0.4934 12.4 0.666733 15.2933C0.746733 15.96 0.826733 16.6267 1.0534 17.2933C1.24007 18.0933 1.60007 18.8933 2.00007 19.6C3.44007 21.9067 5.9334 23.56 8.6134 23.8933C11.4667 24.2533 14.5201 23.7333 16.7067 21.76C19.1467 19.5467 20.0001 16 18.7467 12.96L18.5734 12.6133C18.2934 12 17.5467 10.9333 17.5467 10.9333ZM13.3334 19.3333C12.9601 19.6533 12.3467 20 11.8667 20.1333C10.3734 20.6667 8.88007 19.92 8.00007 19.04C9.58673 18.6667 10.5334 17.4933 10.8134 16.3067C11.0401 15.24 10.6134 14.36 10.4401 13.3333C10.2801 12.3467 10.3067 11.5067 10.6667 10.5867C10.9201 11.0933 11.1867 11.6 11.5067 12C12.5334 13.3333 14.1467 13.92 14.4934 15.7333C14.5467 15.92 14.5734 16.1067 14.5734 16.3067C14.6134 17.4 14.1334 18.6 13.3334 19.3333Z"
                        fill="white" />
                    </svg>
                    </base-button
                >
              </div>
            </form>
            <p class="error" v-if="errors.invalid">{{ errors.invalid }}</p>
          </validation-observer>
            <!-- <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                <base-input alternative class="mb-2 login-input singup-input" name="Email" :rules="{ required: true }"
                  placeholder="Email Address" v-model="form.email">
                </base-input>
                <div class="row my-3">
                  <div class="col-6 col-md-6"></div>
                  <div class="col-6 col-md-6">
                    <div class="text-right forget-txt">
                      <router-link to="/login">Back to Login ?
                      </router-link>
                    </div>
                  </div>
                </div>

                <div class="text-center signinbtn mb-3">
                  <base-button native-type="submit" class="d-block w-100">Submit
                    <svg width="20" height="24" viewBox="0 0 20 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M17.5467 10.9333C17.2401 10.5333 16.8667 10.1867 16.5201 9.84C15.6267 9.04 14.6134 8.46667 13.7601 7.62667C11.7734 5.68 11.3334 2.46667 12.6001 0C11.3334 0.306667 10.2267 1 9.28007 1.76C5.82673 4.53333 4.46673 9.42667 6.0934 13.6267C6.14673 13.76 6.20007 13.8933 6.20007 14.0667C6.20007 14.36 6.00007 14.6267 5.7334 14.7333C5.42673 14.8667 5.10673 14.7867 4.8534 14.5733C4.77773 14.5099 4.71444 14.4331 4.66673 14.3467C3.16007 12.44 2.92007 9.70667 3.9334 7.52C1.70673 9.33333 0.4934 12.4 0.666733 15.2933C0.746733 15.96 0.826733 16.6267 1.0534 17.2933C1.24007 18.0933 1.60007 18.8933 2.00007 19.6C3.44007 21.9067 5.9334 23.56 8.6134 23.8933C11.4667 24.2533 14.5201 23.7333 16.7067 21.76C19.1467 19.5467 20.0001 16 18.7467 12.96L18.5734 12.6133C18.2934 12 17.5467 10.9333 17.5467 10.9333ZM13.3334 19.3333C12.9601 19.6533 12.3467 20 11.8667 20.1333C10.3734 20.6667 8.88007 19.92 8.00007 19.04C9.58673 18.6667 10.5334 17.4933 10.8134 16.3067C11.0401 15.24 10.6134 14.36 10.4401 13.3333C10.2801 12.3467 10.3067 11.5067 10.6667 10.5867C10.9201 11.0933 11.1867 11.6 11.5067 12C12.5334 13.3333 14.1467 13.92 14.4934 15.7333C14.5467 15.92 14.5734 16.1067 14.5734 16.3067C14.6134 17.4 14.1334 18.6 13.3334 19.3333Z"
                        fill="white" />
                    </svg>
                  </base-button>
                </div>
              </form>
              <p class="error" v-if="errors.invalid">{{ errors.invalid }}</p>
            </validation-observer> -->

          </div>
        </div>
        <div class="col-12 col-md-6 right-bg">
          <div class="inner-right-wrap d-flex flex-column h-100 pt-5 pl-2 pl-md-5">
            <h2 class="text-white mb-2 mb-md-0">Manage Your System!</h2>
            <p class="text-white mb-5">Enter your credentials to unlock our interactive learning dashboard.</p>
            <div class="img-wrap d-flex justify-content-end mt-auto">
              <img class="img-fluid" src="signup-img/admin-img.webp" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="push"></div>

    <!-- <div class="header-section">
      <div class="toplogin-btn">
        <router-link to="/login" class="login-text">Login</router-link>
      </div>
      <div class="container">
        <div class="header-body text-center">
          <div class="row justify-content-center"></div>
        </div>
      </div>
    </div>
    <div class="container-fluid">
      <div class="login-section">
        <div class="white-shadow-box login-box positionUnset">
          <h3 class="text-center mb-5 mt-4">
            Enter Password
          </h3>
          <p class="mb-5 mt-4"></p>
          <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
            <form role="form" @submit.prevent="handleSubmit(onSubmit)">
              <div class="row">
                <div class="col-md-12">
                  <base-input
                    alternative
                    type="password"
                    class="mb-3 login-input"
                    name="New password"
                    :rules="{ required: true }"
                    placeholder="New Password"
                    v-model="form.newpassword"
                  >
                  </base-input>
                </div>
                <div class="col-md-12">
                  <base-input
                    alternative
                    type="password"
                    class="mb-3 login-input"
                    name="Confirm password"
                    :rules="{ required: true }"
                    placeholder="Confirm Password"
                    v-model="form.confirmpassword"
                  >
                  </base-input>
                </div>
              </div>

              <div class="text-right">
                <base-button native-type="submit" class="custom-btn"
                  >Submit</base-button
                >
              </div>
            </form>
            <p class="error" v-if="errors.invalid">{{ errors.invalid }}</p>
          </validation-observer>
        </div>
      </div>
    </div>
    <div class="push"></div> -->
  </div>
</template>
<script>
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
export default {
  data() {
    return {
      loading: false,
      form: {
        newpassword: "",
        confirmpassword: "",
        link: ""
      },
      errors: {
        invalid: ""
      }
    };
  },
  created() {
    if (this.$route.query.link) {
      this.form.link = this.$route.query.link;
    }
  },
  methods: {
    onSubmit() {
      if (this.form.newpassword == this.form.confirmpassword) {
        this.loading = true;
        this.$http
          .post("user/resetPassword", {
            link: this.form.link,
            new_password: this.form.newpassword
          })
          .then(resp => {
            this.$router.push("/login");
            Swal.fire({
              text: "Password updated successfully. You can now login.",
              icon: "success",
              confirmButtonClass: "btn btn-success btn-fill"
            });
          })
          .catch(function(error) {
            Swal.fire({
              title: "Error!",
              text: "Something went wrong! Please try again.",
              icon: "error"
            });
          })
          .finally(() => (this.loading = false));
      } else {
        Swal.fire({
          text: "Password didn't match!",
          icon: "error",
          confirmButtonClass: "btn btn-success btn-fill"
        });
      }
    }
  }
};
</script>
<style>
body,
html {
  height: 100%;
}

.error {
  color: red;
  text-align: center;
}

.py-5 {
  padding-bottom: 0px !important;
}

.mt--10 {
  margin-top: -10rem !important;
}



.form-section {
  background-color: #e4e8e8;
}

.login-section {
  background-color: #ececf9;
  padding: 0px;
}

.course-section {
  background-color: #ffffff !important;
  padding: 40px;
}

.error {
  color: red;
  text-align: center;
}

.py-5 {
  padding-bottom: 0px !important;
}

.mt--10 {
  margin-top: -10rem !important;
}

.user-icon {
  font-size: 10rem;
  padding-bottom: 1.3rem;
  color: #28c0e7;
}

.user-icon-company {
  font-size: 11.2rem;
  padding-bottom: 0;
  color: #28c0e7;
}

.singup-option {
  /* display: flex;
    justify-content: flex-end; */
  font-size: 15px;
}

.singup-option a {
  color: #1e1e1e;
  font-weight: 500;
}

.btn.custom-btn {
  background-color: #80d610;
  border-color: #80d610;
}

.left-bg {
  background: #f3f3f3 url("/signup-img/signup_bg1.svg") no-repeat right bottom;

}

.right-bg {
  background: url("/signup-img/signup_bg2.svg") no-repeat center center;
  background-size: cover;
}

.img-wrap {
  margin-right: -15px;
}

html,
body,
.window-hight {
  height: 100vh;
  /* overflow: hidden; */
}

.sinup-container {
  font-family: "Inter", serif;
  color: #1e1e1e;
}

.signin-header h3 {
  font-size: 32px;
  font-weight: 500;
  color: #1e1e1e;
  line-height: 50px;
}
.signin-header span {
  color: #656565;
}
.signin-header span a {
  color: #656565;
}

.signin-header h3 img {
  margin-top: -13px;
}

.chk-container {
  display: block;
  position: relative;
  padding-left: 30px;
  margin-bottom: 0;
  color: #656565;
  cursor: pointer;
  font-size: 15px !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.chk-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.chk-container .checkmark {
  position: absolute;
  top: 0;
  left: 0;
  height: 22px;
  width: 22px;
  background-color: #E8E7E7;
  border: 1px solid #D2CECE;
}


/* On mouse-over, add a grey background color */


/* When the checkbox is checked, add a blue background */
.chk-container input:checked~.checkmark {
  background-color: #FE672C;
  border-color: #FE672C;
}

/* Create the checkmark/indicator (hidden when not checked) */
.chk-container .checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.chk-container input:checked~.checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.chk-container .checkmark:after {
  left: 9px;
  top: 5px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

.forget-txt a {
  font-size: 15px;
  color: #FE672C;
  font-weight: 500;
  border-bottom: 1px solid #FE672C;
}

.forget-txt a:hover {
  border-bottom: 0;
}

.signinbtn .btn {
  background: linear-gradient(to bottom, #e48e39 0%, #ea2628 100%);
  border: 0;
  height: 60px;
  font-size: 25px;
  font-weight: normal;
  transform: none;
}

.signinbtn .btn:hover {
  opacity: .8;
}

.signinbtn .btn svg {
  margin-top: -4px;
}

.inner-right-wrap h2 {
  font-size: 50px;
  font-weight: 500;
}

.inner-right-wrap p {
  font-size: 20px;
  max-width: 70%;
}

@media (max-width: 767px) {
  .singup-input .form-control {
    height: 50px !important;
  }

  .signinbtn .btn {
    height: 50px;
    line-height: 27px;
    font-size: 20px;
  }

  .inner-right-wrap h2 {
    font-size: 30px;
  }

  .inner-right-wrap p {
    font-size: 18px;
    max-width: 100%;
  }
}
</style>
